import { useAuth } from 'auth/hooks/useAuth';
import Moment from 'moment';
import { FormWithValidation } from 'shared/form';
import { LOGIN_ERROR_MESSAGES } from 'auth/constants/LoginErrorMessages';
import { Button, Grid } from '@orbita-ui/core';
import { HomeContainer } from './HomePage.styles';
import { PBody, PageTitle } from 'shared/components/Fonts';
import { Card } from 'shared/components';

export function HomePage() {
  const { user, loginAsUser } = useAuth();

  const formatDate = () => {
    const date = Moment(user?.lastLogin);
    return date.format('DD/MM/YYYY HH:mm');
  };

  const searchCodigo = ({ username }) => {
    loginAsUser(username);
  };

  if (user?.tipoUsuario === 'PRISMA') {
    return (
      <Grid>
        <Grid.Item xs={4}>
          <PageTitle>
            Te damos la bienvenida a <span>Mis Tarjetas Recargables</span>
          </PageTitle>
        </Grid.Item>
        <Grid.Item xs={4}>
          <PBody $bold>Un mundo de información en un solo click</PBody>
        </Grid.Item>
        <Grid.Item xs={4}>
          <PBody>
            Bienvenido a la plataforma en línea que le permite acceder a la información
            más completa sobre la actividad de compra de las tarjetas Visa Electron Flota
            de su organismo.
          </PBody>
          <PBody>
            Como administrador de la cuenta, usted accede a un servicio único que le
            permite conocer con precisión el estado de las cuentas y tarjetas Visa
            Electron Flota de su organismo, desde cualquier lugar del mundo, las 24 horas
            del día, todos los días.
          </PBody>
        </Grid.Item>
        <Grid.Item xs={4}>
          <Card>
            <Card.Title>Buscar usuario</Card.Title>
            <Card.Body $padding>
              <FormWithValidation onSubmit={searchCodigo}>
                <FormWithValidation.TextInput
                  name="username"
                  label="Código de usuario"
                  placeholder="Código de usuario"
                  fullWidth
                  registerOptions={{
                    required: LOGIN_ERROR_MESSAGES.codigoEmpty,
                  }}
                />
                <div>
                  <Button type="submit">Consultar</Button>
                </div>
              </FormWithValidation>
            </Card.Body>
          </Card>
        </Grid.Item>
      </Grid>
    );
  }

  return (
    <HomeContainer>
      <div className="info">
        <Grid>
          <Grid.Item>
            <PageTitle>
              Te damos la bienvenida a <span>Mis Tarjetas Recargables</span>
            </PageTitle>
          </Grid.Item>
          <Grid.Item>
            <p>
              La supervisión y el control de gastos corporativos son de vital importancia.
              Para facilitar esta gestión, Visa impulsa el desarrollo de nuevas
              herramientas en la plataforma de Tarjetas Recargables para Empresas. Con
              aplicaciones específicas para diferentes ámbitos (Administración de Flota,
              Administración de Gastos de Representación, Compras Institucionales, etc.),
              ofrece soluciones completas para las empresas.
            </p>
          </Grid.Item>
          <Grid.Item>
            <p>
              El sistema facilita la reasignación en línea de saldos disponibles y
              proporciona la información necesaria para una adecuada rendición de gastos.
            </p>
          </Grid.Item>
        </Grid>
      </div>
      <div className="bottom">
        <p className="text-end">
          Último inicio de sesión: <span>{formatDate()}</span>
        </p>
      </div>
    </HomeContainer>
  );
}
